import { render, staticRenderFns } from "./AddressEditor.vue?vue&type=template&id=140ec082"
import script from "./AddressEditor.vue?vue&type=script&lang=js"
export * from "./AddressEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports